import React from 'react';
import { StarIcon } from 'lucide-react';
import { motion } from 'framer-motion';
const TESTIMONIOS = [{
  name: 'Lucía M.',
  city: 'Córdoba',
  text: '¡Me salvó la vida! Doy clases en 3 colegios distintos y no daba abasto con la planificación. El material está impecable y a los chicos les encanta la parte de speaking.'
}, {
  name: 'Valentina R.',
  city: 'Rosario',
  text: 'Lo que más destaco es que sea multinivel. Tengo cursos muy desparejos y con este pack puedo adaptar la misma unidad para todos sin volverme loca buscando cosas extra.'
}, {
  name: 'Camila S.',
  city: 'CABA',
  text: 'Compré varios packs antes pero este es el único que realmente está pensado para secundaria. Los temas son actuales y las worksheets están listas para imprimir. Un 10.'
}, {
  name: 'Florencia D.',
  city: 'Mendoza',
  text: 'Ahorré muchísimas horas de mi fin de semana. El hecho de que traiga la clave de respuestas y las evaluaciones armadas vale cada peso. Lo recontra recomiendo.'
}, {
  name: 'María José L.',
  city: 'La Plata',
  text: 'Excelente inversión. Lo uso tanto para mis clases en el instituto como para mis alumnos particulares. El bono de English Eras es espectacular para salir de la rutina.'
}];
export function Testimonios() {
  return <section className="pt-8 pb-12 bg-orange-50/50" data-id="element-227">
      <div className="max-w-6xl mx-auto px-4" data-id="element-228">
        <div className="text-center mb-8" data-id="element-229">
          <h2 className="text-4xl md:text-5xl font-black text-gray-900 uppercase" data-id="element-230">
            Lo que dicen quienes ya lo usan
          </h2>
          <div className="w-24 h-2 bg-orange-400 mx-auto mt-6 rounded-full" data-id="element-231"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-232">
          {TESTIMONIOS.map((testimonio, index) => <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} key={index} className="bg-white p-8 rounded-2xl shadow-md border border-orange-100 flex flex-col" data-id="element-233">
              <div className="flex gap-1 mb-4" data-id="element-234">
                {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-5 h-5 fill-yellow-400 text-yellow-400" data-id="element-235" />)}
              </div>
              <p className="text-gray-700 italic mb-6 flex-1 text-lg" data-id="element-236">
                "{testimonio.text}"
              </p>
              <div className="flex items-center gap-3 mt-auto pt-4 border-t border-gray-100" data-id="element-237">
                <div className="w-10 h-10 bg-orange-100 rounded-full flex items-center justify-center text-orange-600 font-bold text-lg" data-id="element-238">
                  {testimonio.name.charAt(0)}
                </div>
                <div data-id="element-239">
                  <p className="font-bold text-gray-900" data-id="element-240">{testimonio.name}</p>
                  <p className="text-sm text-gray-500" data-id="element-241">{testimonio.city}</p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}